import { render, staticRenderFns } from "./token.vue?vue&type=template&id=4408da6b&scoped=true"
import script from "./token.vue?vue&type=script&lang=js"
export * from "./token.vue?vue&type=script&lang=js"
import style0 from "./token.vue?vue&type=style&index=0&id=4408da6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408da6b",
  null
  
)

export default component.exports